document.addEventListener('DOMContentLoaded', () => {
	const el = document.getElementById('datetime');
	if (el) {
		el.textContent = String(new Date().getFullYear());
	}
});